<!-- HEADER / NAVIGATION -->
<header class="navbar" [class.scrolled]="isScrolled()">
  <div class="container">
    <div class="logo-container" (click)="closeAllModals()" style="display: flex; align-items: center; gap: 12px; cursor: pointer;">
      <app-logo size="sm"></app-logo>
      <div style="border-left: 1px solid var(--border-color); padding-left: 12px; height: 24px; display: flex; align-items: center;">
        <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.25rem; font-weight: 800; letter-spacing: -0.01em;">Partner</span>
      </div>
    </div>

    <nav>
      <ul class="nav-links">
        <li><a href="#features" class="active">Features</a></li>
        <li><a href="#stats">Impact</a></li>
        <li><a href="#benefits">Network</a></li>
        <li><a href="#inquiries" (click)="$event.preventDefault(); openContact()">Inquiry Form</a></li>
      </ul>
    </nav>

    <div class="nav-actions">
      <!-- Light/Dark Toggle Button -->
      <button 
        class="theme-toggle-btn" 
        (click)="partnerService.toggleTheme()" 
        aria-label="Toggle Theme"
      >
        @if (partnerService.isDarkMode()) {
          <!-- Sun Icon (Moon on Click) -->
          <svg class="theme-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
        } @else {
          <!-- Moon Icon (Sun on Click) -->
          <svg class="theme-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
        }
      </button>

      <button class="btn btn-outline hover:scale-105 transition-all duration-200" (click)="openStandardLogin()">Login</button>
      <button class="btn btn-outline hover:scale-105 transition-all duration-200" (click)="openLogin()">Onboard</button>
      <button class="btn btn-primary hover:scale-105 transition-all duration-200" (click)="openGetStarted()">Get Started</button>
    </div>

    <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" aria-label="Toggle Menu">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
    </button>
  </div>
</header>

<!-- MOBILE MENU DRAWER -->
@if (mobileMenuOpen()) {
  <div class="mobile-drawer glass">
    <div class="drawer-header">
      <div class="logo-container" style="display: flex; align-items: center; gap: 12px;">
        <app-logo size="sm"></app-logo>
        <div style="border-left: 1px solid var(--border-color); padding-left: 12px; height: 24px; display: flex; align-items: center;">
          <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.25rem; font-weight: 800; letter-spacing: -0.01em;">Partner</span>
        </div>
      </div>
      <button class="modal-close-btn" style="position: static;" (click)="toggleMobileMenu()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <ul class="drawer-links">
      <li><a href="#features" (click)="toggleMobileMenu()">Features</a></li>
      <li><a href="#stats" (click)="toggleMobileMenu()">Impact</a></li>
      <li><a href="#benefits" (click)="toggleMobileMenu()">Network</a></li>
      <li><a href="#inquiries" (click)="toggleMobileMenu(); openContact()">Inquiry Form</a></li>
    </ul>
    <div class="drawer-actions">
      <button class="theme-toggle-btn" (click)="partnerService.toggleTheme(); toggleMobileMenu()" style="width: 100%; justify-content: center; gap: 8px;">
        @if (partnerService.isDarkMode()) {
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg> Switch Light Mode
        } @else {
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg> Switch Dark Mode
        }
      </button>
      <button class="btn btn-outline" style="width: 100%;" (click)="toggleMobileMenu(); openStandardLogin()">Login</button>
      <button class="btn btn-outline" style="width: 100%;" (click)="toggleMobileMenu(); openLogin()">Onboarded</button>
      <button class="btn btn-primary" style="width: 100%;" (click)="toggleMobileMenu(); openGetStarted()">Get Started</button>
    </div>
  </div>
}

<!-- MAIN HERO SECTION -->
<section class="hero">
  <div class="container">
    <div class="hero-grid">
      <div class="hero-content">
        <div class="credits-badge" style="margin-bottom: 20px; font-size: 0.85rem;">
          <span class="pulse-indicator"></span> Partner Program 2026 Active
        </div>
        <h1 class="gradient-text">Powering Decentralized Corporate Accounting Networks</h1>
        <p>
          Join the next-generation partner ecosystem. Seamlessly synchronize corporate workflows, integrate decentralized ledger interfaces, and monetize high-volume transacting client bases.
        </p>
        <div class="hero-btns">
          <button class="btn btn-primary" (click)="openGetStarted()">
            Get Started <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
          </button>
          <button class="btn btn-secondary" (click)="openContact()">Contact Us</button>
        </div>
      </div>

      <div class="hero-graphic">
        <div class="hero-image-glow"></div>
        <img 
          [src]="partnerService.isDarkMode() ? '/hero_dashboard.png' : '/hero_dashboard_light.png'" 
          alt="Futuristic DeFi Partner Ledger Dashboard" 
          class="hero-image" 
          width="500" 
          height="500"
        />
      </div>
    </div>
  </div>
</section>

<!-- PARTNER STATS / IMPACT -->
<section id="stats" class="stats-section">
  <div class="container">
    <div class="stats-grid">
      <div class="stat-card glass">
        <div class="stat-num">12.4B+</div>
        <div class="stat-label">Total Volume</div>
      </div>
      <div class="stat-card glass">
        <div class="stat-num">8,000+</div>
        <div class="stat-label">Active Global Nodes</div>
      </div>
      <div class="stat-card glass">
        <div class="stat-num">99.99%</div>
        <div class="stat-label">API Service Uptime</div>
      </div>
      <div class="stat-card glass">
        <div class="stat-num">140+</div>
        <div class="stat-label">Connected Countries</div>
      </div>
    </div>
  </div>
</section>

<!-- BENEFITS / FEATURE CARDS -->
<section id="features" class="benefits">
  <div class="container">
    <div class="section-header">
      <h2 class="gradient-text-alt">Why Partner with Hashbooks?</h2>
      <p>Gain access to specialized clearing infrastructures, high-throughput accounting integrations, and lucrative revenue sharing pipelines.</p>
    </div>

    <div class="benefits-grid">
      <div class="benefit-card glass">
        <div class="benefit-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path></svg>
        </div>
        <h3>Corporate Clearing APIs</h3>
        <p>Deploy enterprise-grade clearing functions into your legacy apps. Support 100k+ TPS with near-zero clearing latency.</p>
      </div>

      <div class="benefit-card glass">
        <div class="benefit-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
        </div>
        <h3>Cryptographic Security</h3>
        <p>Leverage zero-knowledge clearing proofs to assert compliance bounds without exposing raw transaction parameters.</p>
      </div>

      <div class="benefit-card glass">
        <div class="benefit-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
        </div>
        <h3>Symmetric Revenues</h3>
        <p>Earn passive clearing fees on all transactions synchronized across your whitelisted business networks.</p>
      </div>
    </div>
  </div>
</section>

<!-- CTA / BANNER SECTION -->
<section class="cta-banner">
  <div class="container">
    <div class="cta-box glass">
      <h2 class="gradient-text">Ready to scale your financial ecosystem?</h2>
      <p>Integrate our secure ledger gateway service nodes in less than 10 minutes. A corporate account representative will guide your clearing setup.</p>
      <div class="hero-btns" style="justify-content: center;">
        <button class="btn btn-primary" (click)="openGetStarted()">Get Started Today</button>
        <button class="btn btn-outline" (click)="openContact()">Request Call</button>
      </div>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer class="footer">
  <div class="container">
    <div class="footer-grid">
      <div class="footer-brand">
        <div class="logo-container" style="display: flex; align-items: center; gap: 14px; margin-bottom: 16px;">
          <app-logo size="md"></app-logo>
          <div style="border-left: 1px solid var(--border-color); padding-left: 14px; height: 32px; display: flex; align-items: center;">
            <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.45rem; font-weight: 800; letter-spacing: -0.01em;">Partner</span>
          </div>
        </div>
        <p>
          Advanced decentralized corporate bookkeeping system and peer-to-peer financial clearing protocols.
        </p>
      </div>

      <div class="footer-col">
        <h4>Solutions</h4>
        <ul>
          <li><a href="#features">Developer Portal</a></li>
          <li><a href="#features">Corporate Clearing</a></li>
          <li><a href="#features">Auditing Infrastructure</a></li>
        </ul>
      </div>

      <div class="footer-col">
        <h4>Programs</h4>
        <ul>
          <li><a href="#stats">Referral Network</a></li>
          <li><a href="#features">Integration Partners</a></li>
          <li><a href="#cta">SaaS Resellers</a></li>
        </ul>
      </div>

      <div class="footer-col">
        <h4>Company</h4>
        <ul>
          <li><a href="#">Privacy Policy</a></li>
          <li><a href="#">Terms & Conditions</a></li>
          <li><a href="#">System Status</a></li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <span>© 2026 Hashbooks Inc. All rights reserved.</span>
      <span class="credits">Designed & Developed by <a href="#inquiries" (click)="$event.preventDefault(); openContact()" style="color: var(--primary); font-weight:600;">Dhivya & Madhan</a></span>
    </div>
  </div>
</footer>

<!-- MODAL 1: CONTACT US INQUIRY (Dhivya & Madhan) -->
@if (isContactOpen()) {
  <div class="modal-overlay" (click)="closeAllModals()">
    <div class="modal-content glass" (click)="$event.stopPropagation()">
      <button class="modal-close-btn" (click)="closeAllModals()" aria-label="Close modal">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>

      <div class="modal-inner">
        @if (!contactSubmitted()) {
          <div class="contact-header">
            <h2>Partner With Us</h2>
            <p>Submit your details and our team will get in touch.</p>
            <!-- <div class="credits-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
              Engineers Assigned: Dhivya & Madhan
            </div> -->
          </div>

          <form class="partner-form" (submit)="$event.preventDefault(); handleContactSubmit()" novalidate>
            <!-- Name -->
            <div class="form-group">
              <label for="contact-name" class="form-label">UBO/ Director Full Name</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                <input 
                  type="text" 
                  id="contact-name" 
                  name="name" 
                  class="form-input" 
                  placeholder="John Doe"
                  maxlength="100"
                  [(ngModel)]="contactForm.name"
                  (input)="onNameInput($event)"
                />
              </div>
              @if (contactErrors()['name']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ contactErrors()['name'] }}</span>
              }
            </div>

            <!-- Company Name -->
            <div class="form-group">
              <label for="contact-company-name" class="form-label">Company Name</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                <input 
                  type="text" 
                  id="contact-company-name" 
                  name="company_name" 
                  class="form-input" 
                  placeholder="WazirX Technologies"
                  maxlength="100"
                  [(ngModel)]="contactForm.company_name"
                  (input)="onCompanyNameInput($event)"
                />
              </div>
              @if (contactErrors()['company_name']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ contactErrors()['company_name'] }}</span>
              }
            </div>

            <!-- Email -->
            <div class="form-group">
              <label for="contact-email" class="form-label">Email Address</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                <input 
                  type="email" 
                  id="contact-email" 
                  name="email" 
                  class="form-input" 
                  placeholder="partner@yopmail.com"
                  maxlength="254"
                  [(ngModel)]="contactForm.email"
                  (input)="onEmailInput($event)"
                />
              </div>
              @if (contactErrors()['email']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ contactErrors()['email'] }}</span>
              }
            </div>

            <!-- Phone -->
            <div class="form-group">
              <label for="contact-phone" class="form-label">Phone Number</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                <input 
                  type="tel" 
                  id="contact-phone" 
                  name="phone" 
                  class="form-input" 
                  placeholder="+91 9988776655"
                  maxlength="18"
                  [(ngModel)]="contactForm.phone"
                  (ngModelChange)="revalidateContactField('phone')"
                />
              </div>
              @if (contactErrors()['phone']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ contactErrors()['phone'] }}</span>
              }
            </div>

            <!-- Country Selection -->
            <div class="form-group">
              <label for="contact-country" class="form-label">Country</label>
              <div class="select-wrapper">
                <select 
                  id="contact-country" 
                  name="country" 
                  class="form-input" 
                  style="padding-left: 16px;"
                  [(ngModel)]="contactForm.country"
                  (ngModelChange)="revalidateContactField('country')"
                >
                  <option value="" disabled selected>Select location...</option>
                  @for (country of countries; track country) {
                    <option [value]="country">{{ country }}</option>
                  }
                </select>
              </div>
              @if (contactErrors()['country']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ contactErrors()['country'] }}</span>
              }
            </div>

            <!-- Company Identity Number -->
            <div class="form-group">
              <label for="contact-company-identity" class="form-label">Company Registration Number </label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="4"></line><line x1="8" y1="2" x2="8" y2="4"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                <input 
                  type="text" 
                  id="contact-company-identity" 
                  name="company_identity_number" 
                  class="form-input" 
                  placeholder="e.g., GSTIN29ABCDE1234F1Z5"
                  maxlength="30"
                  [(ngModel)]="contactForm.company_identity_number"
                  (input)="onCompanyIdentityInput($event)"
                />
              </div>
              @if (contactErrors()['company_identity_number']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ contactErrors()['company_identity_number'] }}</span>
              }
            </div>

            <!-- Address -->
            <div class="form-group form-group-full">
              <label for="contact-address" class="form-label">Company Address</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <input 
                  type="text" 
                  id="contact-address" 
                  name="address" 
                  class="form-input" 
                  placeholder="e.g., Hitech City, Hyderabad, Telangana"
                  maxlength="200"
                  [(ngModel)]="contactForm.address"
                  (ngModelChange)="revalidateContactField('address')"
                />
              </div>
              @if (contactErrors()['address']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ contactErrors()['address'] }}</span>
              }
            </div>



            <!-- Message -->
            <div class="form-group form-group-full">
              <label for="contact-msg" class="form-label">Message / Inquiry</label>
              <textarea 
                id="contact-msg" 
                name="message" 
                class="form-input" 
                placeholder="Tell us about your company and partnership goals..."
                maxlength="1000"
                [(ngModel)]="contactForm.message"
                (ngModelChange)="revalidateContactField('message')"
              ></textarea>
              @if (contactErrors()['message']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ contactErrors()['message'] }}</span>
              }
            </div>

            <!-- Submit -->
            <div class="form-group form-group-full" style="margin-top: 10px;">
              <button 
                type="submit" 
                class="btn btn-primary" 
                style="width: 100%; height: 48px;"
                [disabled]="isSubmittingContact()"
              >
                @if (isSubmittingContact()) {
                  Submitting Request...
                } @else {
                  Submit Request
                }
              </button>
            </div>
          </form>
        } @else {
          <!-- Dynamic Success State -->
          <div class="success-container animate-fade">
            <div class="checkmark-circle">
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
            <h2 class="gradient-text">Request Submitted!</h2>
            <p>
              Your partner application has been queued successfully. Our team will review your submission and contact you shortly.
            </p>
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- MODAL 2: 3-STEP ONBOARDING WIZARD (Get Started) -->
@if (isGetStartedOpen()) {
  <div class="modal-overlay" (click)="closeAllModals()">
    <div class="modal-content glass" (click)="$event.stopPropagation()">
      <button class="modal-close-btn" (click)="closeAllModals()" aria-label="Close modal">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>

      <div class="modal-inner">
        @if (!startedSubmitted()) {
          <!-- Step Headers indicators -->
          <div class="wizard-steps-header">
            <div class="wizard-step-node" [class.active]="startedStep() >= 1" [class.complete]="startedStep() > 1">
              <span>1</span>
              <label>Admin Profile</label>
            </div>
            <div class="wizard-step-line" [class.active]="startedStep() > 1"></div>
            <div class="wizard-step-node" [class.active]="startedStep() >= 2" [class.complete]="startedStep() > 2">
              <span>2</span>
              <label>Partnership</label>
            </div>
            <div class="wizard-step-line" [class.active]="startedStep() > 2"></div>
            <div class="wizard-step-node" [class.active]="startedStep() >= 3" [class.complete]="startedStep() > 3">
              <span>3</span>
              <label>Integration</label>
            </div>
          </div>

          <form (submit)="$event.preventDefault()" novalidate>
            <!-- STEP 1: Profile Credentials -->
            @if (startedStep() === 1) {
              <div class="contact-header" style="margin-top: 15px;">
                <h2>Partner Security Profile</h2>
                <p>Register administrative console keys and secure passphrase access.</p>
              </div>
              
              <div class="partner-form">
                <div class="form-group form-group-full">
                  <label for="step-name" class="form-label">Administrative Representative Name</label>
                  <div class="form-input-wrapper">
                    <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    <input 
                      type="text" 
                      id="step-name" 
                      name="fullName" 
                      class="form-input" 
                      placeholder="John Doe" 
                      [(ngModel)]="startedForm.fullName"
                    />
                  </div>
                  @if (startedErrors()['fullName']) {
                    <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ startedErrors()['fullName'] }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="step-email" class="form-label">Corporate Email Address</label>
                  <div class="form-input-wrapper">
                    <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                    <input 
                      type="email" 
                      id="step-email" 
                      name="businessEmail" 
                      class="form-input" 
                      placeholder="john@company.com" 
                      [(ngModel)]="startedForm.businessEmail"
                      (input)="onBusinessEmailInput($event)"
                    />
                  </div>
                  @if (startedErrors()['businessEmail']) {
                    <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ startedErrors()['businessEmail'] }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="step-pass" class="form-label">Access Passphrase (Min 8 chars)</label>
                  <div class="form-input-wrapper">
                    <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                    <input 
                      type="password" 
                      id="step-pass" 
                      name="password" 
                      class="form-input" 
                      placeholder="••••••••" 
                      [(ngModel)]="startedForm.password"
                    />
                  </div>
                  @if (startedErrors()['password']) {
                    <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ startedErrors()['password'] }}</span>
                  }
                </div>
              </div>
            }

            <!-- STEP 2: Partnership Tiers -->
            @if (startedStep() === 2) {
              <div class="contact-header" style="margin-top: 15px; text-align: center;">
                <h2>Partnership Alignment</h2>
                <p>Choose the partnership category that reflects your ledger gateway role.</p>
              </div>
              
              <div class="partnership-tiers-grid">
                <div 
                  class="tier-selector-card glass" 
                  [class.selected]="startedForm.partnerType === 'integration'"
                  (click)="selectPartnerType('integration')"
                >
                  <div class="tier-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path></svg>
                  </div>
                  <h4>Integration Partner</h4>
                  <p>Integrate clearing APIs inside proprietary SaaS, ERP, or clearing platform ecosystems.</p>
                </div>

                <div 
                  class="tier-selector-card glass" 
                  [class.selected]="startedForm.partnerType === 'marketing'"
                  (click)="selectPartnerType('marketing')"
                >
                  <div class="tier-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                  </div>
                  <h4>White-Label Reseller</h4>
                  <p>Re-sell ledger clearance nodes branded under corporate regional structures.</p>
                </div>

                <div 
                  class="tier-selector-card glass" 
                  [class.selected]="startedForm.partnerType === 'referral'"
                  (click)="selectPartnerType('referral')"
                >
                  <div class="tier-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  </div>
                  <h4>Strategic Referral</h4>
                  <p>Introduce enterprise clearing clients and receive recurring transacting cuts.</p>
                </div>
              </div>
            }

            <!-- STEP 3: Integration Scope -->
            @if (startedStep() === 3) {
              <div class="contact-header" style="margin-top: 15px;">
                <h2>Integration Technical Scope</h2>
                <p>Specify clearing target properties and sign cryptographical covenants.</p>
              </div>
              
              <div class="partner-form">
                <div class="form-group form-group-full">
                  <label for="step-plat" class="form-label">Client Platform Name (To link API calls)</label>
                  <div class="form-input-wrapper">
                    <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line></svg>
                    <input 
                      type="text" 
                      id="step-plat" 
                      name="platformName" 
                      class="form-input" 
                      placeholder="Apex Clearing Core" 
                      [(ngModel)]="startedForm.platformName"
                    />
                  </div>
                  @if (startedErrors()['platformName']) {
                    <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ startedErrors()['platformName'] }}</span>
                  }
                </div>

                <div class="form-group form-group-full">
                  <label class="form-label">Clearing Clearance Covenants Agreement</label>
                  <div class="agreement-scroll-box glass">
                    <p><strong>Section 1.1: Cryptographical Compliance Covenants</strong></p>
                    <p>
                      This cryptographic clearing integration agreement governs the deployment of Hashbooks partner clearing nodes. The integrating partner guarantees that all transactions routed across the clearing network originate from audited corporate ledger registries. 
                    </p>
                    <p>
                      The partner covenants that no client transactions shall bypass compliance screening matrices. Node keys provided upon verification represent binding cryptographic signatures of ledger fidelity. Any breach of protocol consensus immediately invalidates routed clearing balances.
                    </p>
                  </div>
                  
                  <div style="margin-top: 12px; display: flex; align-items: center; gap: 10px;">
                    <input 
                      type="checkbox" 
                      id="step-agree" 
                      name="agreeToTerms"
                      style="width: 18px; height: 18px; cursor: pointer;"
                      [(ngModel)]="startedForm.agreeToTerms"
                    />
                    <label for="step-agree" style="font-size: 0.85rem; color: var(--text-muted); cursor: pointer; font-weight:600;">
                      I agree to compliance covenants and consensus frameworks.
                    </label>
                  </div>
                  @if (startedErrors()['agreeToTerms']) {
                    <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ startedErrors()['agreeToTerms'] }}</span>
                  }
                </div>
              </div>
            }

            <!-- Navigation buttons -->
            <div class="wizard-navigation-actions" style="margin-top: 30px; display: flex; justify-content: space-between; gap: 16px;">
              <button type="button" class="btn btn-secondary" style="flex: 1; height: 48px;" (click)="handleBackStep()">
                @if (startedStep() === 1) { Cancel } @else { Back }
              </button>
              <button type="button" class="btn btn-primary" style="flex: 1; height: 48px;" (click)="handleNextStep()" [disabled]="isSubmittingStarted()">
                @if (isSubmittingStarted()) {
                  Generating Live Node Keys...
                } @else if (startedStep() === 3) {
                  Finalize Clearance Keys
                } @else {
                  Continue
                }
              </button>
            </div>
          </form>
        } @else {
          <!-- Step Success Output -->
          <div class="success-container animate-fade">
            <div class="checkmark-circle">
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            </div>
            <h2 class="gradient-text">Consensus Formed!</h2>
            <p>
              Your integration partnership console setup is complete. Write down this primary Live Secret clearance token.
            </p>
            
            <div class="secret-reveal-card glass" style="margin-bottom: 30px; text-align: left; padding: 20px; border-radius:12px; border: 1px dashed var(--primary);">
              <span style="font-size: 0.75rem; color: var(--text-dim); text-transform: uppercase;">Primary Live Secret Token (Concealed)</span>
              <div style="font-family: monospace; font-size: 0.95rem; font-weight: 700; color: #10b981; margin-top: 8px; word-break: break-all;">
                {{ startedSecretToken() }}
              </div>
            </div>

            <button class="btn btn-primary" style="width: 100%; height: 48px;" (click)="handleEnterConsole()">
              Enter Dashboard Console
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- MODAL 3: LOGIN / OAUTH PORTAL -->
@if (isLoginOpen()) {
  <div class="modal-overlay" (click)="loginStep() !== 'otp' ? closeAllModals() : null">
    <div class="modal-content glass" style="max-width: 480px; background: var(--bg-login-card); border-color: var(--border-login-card);" (click)="$event.stopPropagation()">
      <button class="modal-close-btn" (click)="closeAllModals()" aria-label="Close modal">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
      
      <div class="modal-inner" style="padding: 32px;">
        @if (loginStep() === 'credentials') {
          <div style="display: flex; flex-direction: column; align-items: center; text-align: center; margin-bottom: 28px;">
            <div style="display: flex; align-items: center; gap: 14px; margin-bottom: 16px;">
              <app-logo size="md"></app-logo>
              <div style="border-left: 1px solid var(--border-color); padding-left: 14px; height: 32px; display: flex; align-items: center;">
                <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.45rem; font-weight: 800; letter-spacing: -0.01em;">Partner</span>
              </div>
            </div>
            <p style="font-size: 0.95rem; color: var(--text-muted); font-weight: 600; margin: 0;">Onboard your account</p>
          </div>

          <form (submit)="$event.preventDefault(); handleLoginSubmit()" novalidate>
            <!-- Email Address Field -->
            <div class="form-group" style="margin-bottom: 18px;">
              <label for="login-email" class="form-label" style="font-weight: 700; font-size: 0.9rem; color: var(--text-main); margin-bottom: 8px;">Email Address</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>
                <input 
                  type="email" 
                  id="login-email" 
                  name="email"
                  class="form-input" 
                  placeholder="name@example.com"
                  [(ngModel)]="loginEmail"
                  (input)="onLoginEmailInput($event)"
                  style="height: 52px; padding-left: 44px; font-weight: 500;"
                />
              </div>
              @if (loginErrors()['email']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ loginErrors()['email'] }}</span>
              }
            </div>

            <!-- Sign In Submit Button -->
            <button 
              id="login-btn-submit"
              type="submit" 
              class="btn btn-primary" 
              style="width: 100%; height: 50px; font-weight: 700; display: flex; align-items: center; justify-content: center; gap: 8px; border-radius: 12px; font-size: 1rem; background: var(--primary); color: #ffffff; box-shadow: 0 4px 15px var(--primary-glow); transition: all 0.2s;"
              [disabled]="isSubmittingLogin()"
            >
              @if (isSubmittingLogin()) {
                Sending OTP...
              } @else {
                Send OTP <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
              }
            </button>
          </form>
        } @else if (loginStep() === 'otp') {
          <!-- OTP Verification View -->
          <div style="display: flex; flex-direction: column; align-items: center; text-align: center; margin-bottom: 28px;">
            <div style="display: flex; align-items: center; gap: 14px; margin-bottom: 16px;">
              <app-logo size="md"></app-logo>
              <div style="border-left: 1px solid var(--border-color); padding-left: 14px; height: 32px; display: flex; align-items: center;">
                <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.45rem; font-weight: 800; letter-spacing: -0.01em;">Partner</span>
              </div>
            </div>
            @if (doesUserExist()) {
              <h2 style="font-family: 'Nunito', sans-serif; font-size: 1.8rem; font-weight: 800; color: var(--text-main); margin-bottom: 8px;">Security Verification</h2>
              <p style="font-size: 0.95rem; color: var(--text-muted); font-weight: 500; margin: 0; line-height: 1.4;">Enter the verification code sent to your email or a backup code, and enter your password</p>
            } @else {
              <h2 style="font-family: 'Nunito', sans-serif; font-size: 1.8rem; font-weight: 800; color: var(--text-main); margin-bottom: 8px;">Create Account</h2>
              <p style="font-size: 0.95rem; color: var(--text-muted); font-weight: 500; margin: 0; line-height: 1.4;">Configure your password and enter the verification code sent to your email to register</p>
            }
          </div>

          <form (submit)="$event.preventDefault(); handleOtpSubmit()" novalidate>
            <!-- Email Address Field -->
            <div class="form-group" style="margin-bottom: 24px;">
              <label class="form-label" style="font-weight: 700; font-size: 0.9rem; color: var(--text-main); margin-bottom: 8px;">Email Address</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>
                <input 
                  type="text" 
                  readonly 
                  [value]="loginEmail"
                  class="form-input" 
                  style="height: 52px; padding-left: 44px; font-weight: 500; background: var(--bg-button-secondary); border-color: transparent; color: var(--text-muted); cursor: not-allowed;"
                />
              </div>
            </div>

            <!-- Password Field -->
            <div class="form-group" style="margin-bottom: 24px;">
              <label for="login-password" class="form-label" style="font-weight: 700; font-size: 0.9rem; color: var(--text-main); margin-bottom: 8px;">
                {{ doesUserExist() ? 'Password' : 'Choose Password' }}
              </label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                <input 
                  [type]="showPassword() ? 'text' : 'password'" 
                  id="login-password" 
                  name="password"
                  class="form-input" 
                  placeholder="••••••••"
                  [(ngModel)]="loginPassword"
                  style="height: 52px; padding-left: 44px; padding-right: 46px; font-weight: 500;"
                />
                <!-- Dynamic Visibility Toggler Eye Icon -->
                <button type="button" (click)="togglePasswordVisibility()" style="position: absolute; right: 14px; background: none; border: none; cursor: pointer; color: var(--text-dim); display: flex; align-items: center; justify-content: center; padding: 0;">
                  @if (showPassword()) {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                  } @else {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  }
                </button>
              </div>
              <!-- Dynamic Password Strength Checklist -->
              @if (loginPassword && !doesUserExist()) {
                @if (!hasEightCharacters || !hasUppercase || !hasLowercase || !hasSpecialChar) {
                  <div class="password-requirements" style="margin-top: 10px; display: flex; flex-direction: column; gap: 6px; padding: 12px; background: rgba(0,0,0,0.02); border-radius: 8px; border: 1px solid var(--border-color);">
                    <span style="font-size: 0.8rem; font-weight: 700; color: var(--text-muted); margin-bottom: 2px;">PASSWORD REQUIREMENTS:</span>
                    
                    @if (!hasEightCharacters) {
                      <div style="display: flex; align-items: center; gap: 8px; font-size: 0.82rem; font-weight: 500; transition: all 0.2s; color: #ef4444;">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                        At least 8 characters
                      </div>
                    }

                    @if (!hasUppercase) {
                      <div style="display: flex; align-items: center; gap: 8px; font-size: 0.82rem; font-weight: 500; transition: all 0.2s; color: #ef4444;">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                        At least one uppercase letter
                      </div>
                    }

                    @if (!hasLowercase) {
                      <div style="display: flex; align-items: center; gap: 8px; font-size: 0.82rem; font-weight: 500; transition: all 0.2s; color: #ef4444;">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                        At least one lowercase letter
                      </div>
                    }

                    @if (!hasSpecialChar) {
                      <div style="display: flex; align-items: center; gap: 8px; font-size: 0.82rem; font-weight: 500; transition: all 0.2s; color: #ef4444;">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                        At least one special character
                      </div>
                    }
                  </div>
                }
              }
              @if (loginErrors()['password']) {
                <span class="form-error"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ loginErrors()['password'] }}</span>
              }
            </div>

            <!-- OTP Input Field -->
            <div class="form-group" style="margin-bottom: 24px;">
              <label class="form-label" style="font-weight: 700; font-size: 0.9rem; color: var(--text-main); margin-bottom: 8px;">Verification Code</label>
              <div style="display: flex; gap: 8px; justify-content: space-between;">
                @for (digit of [0, 1, 2, 3, 4, 5]; track digit) {
                  <input 
                    type="text" 
                    maxLength="1"
                    [id]="'otp-' + digit"
                    [value]="otpCode()[digit]"
                    (input)="onOtpInput($event, digit)"
                    (keydown)="onOtpKeyDown($event, digit)"
                    (paste)="onOtpPaste($event)"
                    style="width: 52px; height: 52px; text-align: center; font-size: 1.25rem; font-weight: 700; border-radius: 12px; border: 1px solid var(--border-color); background: var(--bg-input); color: var(--text-main); box-shadow: 0 2px 4px rgba(0,0,0,0.02); transition: border-color 0.2s;"
                    onfocus="this.style.borderColor='var(--primary)';"
                    onblur="this.style.borderColor='var(--border-color)';"
                  />
                }
              </div>
              @if (otpError()) {
                <span class="form-error" style="display: flex; align-items: center; color: #ef4444; font-size: 0.8rem; margin-top: 8px; font-weight: 600;">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  {{ otpError() }}
                </span>
              }
              <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
                <button 
                  type="button" 
                  (click)="resendLoginOtp()" 
                  [disabled]="isResendingOtp()"
                  style="background: none; border: none; font-size: 0.85rem; font-weight: 600; color: var(--primary); cursor: pointer; display: flex; align-items: center; gap: 4px; padding: 0; text-decoration: underline;"
                >
                  @if (isResendingOtp()) {
                    Resending...
                  } @else {
                    Resend Code
                  }
                </button>
              </div>
            </div>

            <!-- Verify & Login Submit Button -->
            <button 
              id="otp-btn-submit"
              type="submit" 
              class="btn btn-primary" 
              style="width: 100%; height: 50px; font-weight: 700; display: flex; align-items: center; justify-content: center; gap: 8px; border-radius: 12px; font-size: 1rem; background: var(--primary); color: #ffffff; box-shadow: 0 4px 15px var(--primary-glow); transition: all 0.2s;"
              [disabled]="isSubmittingOtp()"
            >
              @if (isSubmittingOtp()) {
                {{ doesUserExist() ? 'Verifying Credentials...' : 'Registering Account...' }}
              } @else {
                {{ doesUserExist() ? 'Verify & Login' : 'Verify & Create Account' }} <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
              }
            </button>

            <!-- Go Back Link -->
            <div style="text-align: center; margin-top: 24px;">
              <a href="#" (click)="$event.preventDefault(); loginStep.set('credentials')" style="font-size: 0.9rem; font-weight: 700; color: var(--text-main); text-decoration: none; transition: opacity 0.2s;" onmouseover="this.style.opacity='0.8'" onmouseout="this.style.opacity='1'">
                Wrong email? <span style="text-decoration: underline;">Go back</span>
              </a>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
}

<!-- MODAL 4: STANDARD LOGIN PORTAL -->
@if (isStandardLoginOpen()) {
  <div class="modal-overlay" (click)="!isStandardLoginOtp() ? closeAllModals() : null">
    <div class="modal-content glass" style="max-width: 480px; padding: 40px; background: var(--bg-login-card); border-color: var(--border-login-card);" (click)="$event.stopPropagation()">
      <button class="modal-close-btn" (click)="closeAllModals()" aria-label="Close modal">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
      @if (!isStandardLoginOtp() && !isForgotPassword()) {
        <div style="display: flex; flex-direction: column; align-items: center; text-align: center; margin-bottom: 32px;">
          <div style="display: flex; align-items: center; gap: 14px; margin-bottom: 32px;">
            <app-logo size="md"></app-logo>
            <div style="border-left: 1px solid var(--border-color); padding-left: 14px; height: 32px; display: flex; align-items: center;">
              <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.45rem; font-weight: 800; letter-spacing: -0.01em;">Partner</span>
            </div>
          </div>
          <h2 style="font-family: 'Nunito', sans-serif; font-size: 2rem; font-weight: 800; color: var(--text-main); margin-bottom: 10px;">Welcome Back</h2>
          <p style="font-size: 1rem; color: var(--text-muted); font-weight: 500; margin: 0;">Sign in to your account</p>
        </div>

        <form (submit)="$event.preventDefault(); handleStandardLoginSubmit()" novalidate>
          <!-- Email Field -->
          <div class="form-group" style="margin-bottom: 24px;">
            <label class="form-label" style="font-weight: 700; font-size: 0.95rem; color: var(--text-main); margin-bottom: 8px;">Email Address</label>
            <div class="form-input-wrapper">
              <svg class="form-input-icon" [style.color]="standardLoginErrors()['email'] ? '#ef4444' : '#64748b'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>
              <input 
                type="email" 
                name="standardLoginEmail"
                class="form-input" 
                placeholder="name@example.com" 
                [(ngModel)]="standardLoginEmail"
                (input)="onStandardLoginEmailInput($event)"
                [style.borderColor]="standardLoginErrors()['email'] ? '#ef4444' : ''"
                style="height: 54px; padding-left: 44px; font-weight: 500; border-radius: 12px; font-size: 1rem;"
              />
            </div>
            @if (standardLoginErrors()['email']) {
              <span class="form-error" style="color: #ef4444; font-size: 0.85rem; display: flex; align-items: center; gap: 6px; margin-top: 8px; font-weight: 500;"><svg width="14" height="14" viewBox="0 0 24 24" fill="#ef4444" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ standardLoginErrors()['email'] }}</span>
            }
          </div>

          <!-- Password Field -->
          <div class="form-group" style="margin-bottom: 12px;">
            <label class="form-label" style="font-weight: 700; font-size: 0.95rem; color: var(--text-main); margin-bottom: 8px;">Password</label>
            <div class="form-input-wrapper">
              <svg class="form-input-icon" [style.color]="standardLoginErrors()['password'] ? '#ef4444' : '#64748b'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
              <input 
                [type]="showPassword() ? 'text' : 'password'" 
                name="standardLoginPassword"
                class="form-input" 
                placeholder="••••••••"
                [(ngModel)]="standardLoginPassword"
                [style.borderColor]="standardLoginErrors()['password'] ? '#ef4444' : ''"
                style="height: 54px; padding-left: 44px; padding-right: 46px; font-weight: 500; border-radius: 12px; font-size: 1rem; letter-spacing: 2px;"
              />
              <button type="button" (click)="togglePasswordVisibility()" style="position: absolute; right: 16px; background: none; border: none; cursor: pointer; color: var(--text-dim); display: flex; align-items: center; justify-content: center; padding: 0;">
                @if (showPassword()) {
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                } @else {
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                }
              </button>
            </div>
            @if (standardLoginErrors()['password']) {
              <span class="form-error" style="color: #ef4444; font-size: 0.85rem; display: flex; align-items: center; gap: 6px; margin-top: 8px; font-weight: 500;"><svg width="14" height="14" viewBox="0 0 24 24" fill="#ef4444" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ standardLoginErrors()['password'] }}</span>
            }
          </div>

          <div style="display: flex; justify-content: flex-end; margin-bottom: 30px;">
            <a href="#" (click)="$event.preventDefault(); isForgotPassword.set(true); forgotPasswordEmail = standardLoginEmail;" class="hover-underline" style="font-size: 0.95rem; font-weight: 700; color: var(--text-main); text-decoration: none;">Forgot password?</a>
          </div>


          <button 
            type="submit" 
            [style.opacity]="(isSubmittingStandardLogin() || standardLoginPassword.length < 8 || !validateEmail(standardLoginEmail)) ? '0.6' : '1'"
            [style.cursor]="(isSubmittingStandardLogin() || standardLoginPassword.length < 8 || !validateEmail(standardLoginEmail)) ? 'not-allowed' : 'pointer'"
            style="width: 100%; height: 54px; font-weight: 700; display: flex; align-items: center; justify-content: center; border-radius: 16px; font-size: 1.05rem; background: #5b9385; color: #ffffff; border: none; transition: all 0.2s; position: relative; overflow: hidden;"
            [disabled]="isSubmittingStandardLogin() || standardLoginPassword.length < 8 || !validateEmail(standardLoginEmail)"
          >
            <span style="display: flex; align-items: center; justify-content: center; gap: 8px; transition: opacity 0.2s;" [style.opacity]="isSubmittingStandardLogin() ? '0' : '1'">
              <span>Sign In</span>
              <svg style="width: 20px; height: 20px;" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </span>
            @if (isSubmittingStandardLogin()) {
              <span style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
                <svg class="animate-spin" style="height: 20px; width: 20px; color: #ffffff;" fill="none" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" style="opacity: 0.25;"></circle>
                  <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" style="opacity: 0.75;"></path>
                </svg>
              </span>
            }
          </button>
        </form>
      } @else if (isStandardLoginOtp()) {

        <!-- OTP Verification / Security Verification View -->
        <div style="display: flex; flex-direction: column; align-items: center; text-align: center; margin-bottom: 28px;">
          <div style="display: flex; align-items: center; gap: 14px; margin-bottom: 32px;">
            <app-logo size="md"></app-logo>
            <div style="border-left: 1px solid var(--border-color); padding-left: 14px; height: 32px; display: flex; align-items: center;">
              <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.45rem; font-weight: 800; letter-spacing: -0.01em;">Partner</span>
            </div>
          </div>
          <h2 style="font-family: 'Nunito', sans-serif; font-size: 1.8rem; font-weight: 800; color: var(--text-main); margin-bottom: 8px;">Security Verification</h2>
          <p style="font-size: 0.95rem; color: var(--text-muted); font-weight: 500; margin: 0; line-height: 1.4;">Enter the verification code sent to your email or a backup code</p>
        </div>

        <form (submit)="$event.preventDefault(); handleStandardOtpSubmit()" novalidate>
          <!-- Email Address Field (Readonly) -->
          <div class="form-group" style="margin-bottom: 24px; text-align: left;">
            <label class="form-label" style="font-weight: 700; font-size: 0.9rem; color: var(--text-main); margin-bottom: 8px;">Email Address</label>
            <div class="form-input-wrapper">
              <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #64748b;"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>
              <input 
                type="text" 
                readonly 
                [value]="standardLoginEmail"
                class="form-input" 
                style="height: 54px; padding-left: 44px; font-weight: 500; border-radius: 12px; background: var(--bg-button-secondary); border-color: transparent; color: var(--text-muted); cursor: not-allowed;"
              />
            </div>
          </div>

          <!-- OTP Input Field -->
          <div class="form-group" style="margin-bottom: 24px; text-align: left;">
            <label class="form-label" style="font-weight: 700; font-size: 0.9rem; color: var(--text-main); margin-bottom: 8px;">Verification Code</label>
            <div style="display: flex; gap: 8px; justify-content: space-between;">
              @for (digit of [0, 1, 2, 3, 4, 5]; track digit) {
                <input 
                  type="text" 
                  maxLength="1"
                  [id]="'standard-otp-' + digit"
                  [value]="otpCode()[digit]"
                  (input)="onOtpInput($event, digit)"
                  (keydown)="onOtpKeyDown($event, digit)"
                  (paste)="onOtpPaste($event)"
                  style="width: 52px; height: 52px; text-align: center; font-size: 1.25rem; font-weight: 700; border-radius: 12px; border: 1px solid var(--border-color); background: var(--bg-input); color: var(--text-main); box-shadow: 0 2px 4px rgba(0,0,0,0.02); transition: border-color 0.2s;"
                  onfocus="this.style.borderColor='var(--primary)';"
                  onblur="this.style.borderColor='var(--border-color)';"
                />
              }
            </div>
            @if (otpError()) {
              <span class="form-error" style="display: flex; align-items: center; color: #ef4444; font-size: 0.8rem; margin-top: 8px; font-weight: 600;">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                {{ otpError() }}
              </span>
            }
          </div>

          <!-- Verify & Login Submit Button -->
          <button 
            type="submit" 
            class="btn btn-primary" 
            style="width: 100%; height: 54px; font-weight: 700; display: flex; align-items: center; justify-content: center; gap: 8px; border-radius: 16px; font-size: 1.05rem; background: #5b9385; color: #ffffff; border: none; box-shadow: 0 4px 15px var(--primary-glow); transition: all 0.2s;"
            [disabled]="isSubmittingOtp()"
          >
            @if (isSubmittingOtp()) {
              Verifying...
            } @else {
              Verify & Login <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            }
          </button>

          <!-- Go Back Link -->
          <div style="text-align: center; margin-top: 24px;">
            <a href="#" (click)="$event.preventDefault(); isStandardLoginOtp.set(false)" style="font-size: 0.95rem; font-weight: 700; color: var(--text-main); text-decoration: none;">
              Wrong email? <span style="text-decoration: underline;">Go back</span>
            </a>
          </div>
        </form>
      } @else if (isForgotPassword()) {
        @if (forgotPasswordStep() === 1) {
          <div style="display: flex; flex-direction: column; align-items: center; text-align: center; margin-bottom: 24px;">
            <div style="display: flex; align-items: center; gap: 14px; margin-bottom: 24px;">
              <app-logo size="md"></app-logo>
              <div style="border-left: 1px solid var(--border-color); padding-left: 14px; height: 32px; display: flex; align-items: center;">
                <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.45rem; font-weight: 800; letter-spacing: -0.01em;">Partner</span>
              </div>
            </div>
            <h2 style="font-family: 'Nunito', sans-serif; font-size: 2rem; font-weight: 800; color: var(--text-main); margin-bottom: 8px;">Forgot Password?</h2>
            <p style="font-size: 1rem; color: var(--text-muted); font-weight: 500; margin: 0;">Enter your email to reset your password</p>
          </div>

          <form (submit)="$event.preventDefault(); handleForgotPasswordSubmit()" novalidate>
            <!-- Email Field -->
            <div class="form-group" style="margin-bottom: 24px; text-align: left;">
              <label class="form-label" style="font-weight: 700; font-size: 0.95rem; color: var(--text-main); margin-bottom: 8px;">Email Address</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" [style.color]="forgotPasswordErrors()['email'] ? '#ef4444' : '#64748b'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>
                <input 
                  type="email" 
                  name="forgotPasswordEmail"
                  class="form-input" 
                  placeholder="name@example.com" 
                  [(ngModel)]="forgotPasswordEmail"
                  (input)="onForgotPasswordEmailInput($event)"
                  [style.borderColor]="forgotPasswordErrors()['email'] ? '#ef4444' : ''"
                  style="height: 54px; padding-left: 44px; font-weight: 500; border-radius: 12px; font-size: 1rem;"
                />
              </div>
              @if (forgotPasswordErrors()['email']) {
                <span class="form-error" style="color: #ef4444; font-size: 0.85rem; display: flex; align-items: center; gap: 6px; margin-top: 8px; font-weight: 500;"><svg width="14" height="14" viewBox="0 0 24 24" fill="#ef4444" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ forgotPasswordErrors()['email'] }}</span>
              }
            </div>

            <!-- Submit Button -->
            <button 
              type="submit" 
              [style.opacity]="(isSubmittingForgotPassword() || !validateEmail(forgotPasswordEmail)) ? '0.6' : '1'"
              [style.cursor]="(isSubmittingForgotPassword() || !validateEmail(forgotPasswordEmail)) ? 'not-allowed' : 'pointer'"
              style="width: 100%; height: 54px; font-weight: 700; display: flex; align-items: center; justify-content: center; border-radius: 16px; font-size: 1.05rem; background: #5b9385; color: #ffffff; border: none; transition: all 0.2s; position: relative; overflow: hidden; margin-bottom: 24px;"
              [disabled]="isSubmittingForgotPassword() || !validateEmail(forgotPasswordEmail)"
            >
              <span style="display: flex; align-items: center; justify-content: center; gap: 8px; transition: opacity 0.2s;" [style.opacity]="isSubmittingForgotPassword() ? '0' : '1'">
                <span>Send Reset Code</span>
                <svg style="width: 20px; height: 20px;" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>
              @if (isSubmittingForgotPassword()) {
                <span style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
                  <svg class="animate-spin" style="height: 20px; width: 20px; color: #ffffff;" fill="none" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" style="opacity: 0.25;"></circle>
                    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" style="opacity: 0.75;"></path>
                  </svg>
                </span>
              }
            </button>

            <!-- Back to Sign in link -->
            <div style="text-align: center; font-size: 0.95rem; font-weight: 500; color: var(--text-muted);">
              Remember your password? <a href="#" (click)="$event.preventDefault(); isForgotPassword.set(false)" class="hover-underline" style="font-weight: 700; color: var(--text-main); text-decoration: none;">Sign in</a>
            </div>
          </form>
        } @else {
          <!-- Set New Password step 2 -->
          <div style="display: flex; flex-direction: column; align-items: center; text-align: center; margin-bottom: 24px;">
            <div style="display: flex; align-items: center; gap: 14px; margin-bottom: 24px;">
              <app-logo size="md"></app-logo>
              <div style="border-left: 1px solid var(--border-color); padding-left: 14px; height: 32px; display: flex; align-items: center;">
                <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.45rem; font-weight: 800; letter-spacing: -0.01em;">Partner</span>
              </div>
            </div>
            <h2 style="font-family: 'Nunito', sans-serif; font-size: 2rem; font-weight: 800; color: var(--text-main); margin-bottom: 8px;">Set New Password</h2>
            <p style="font-size: 1rem; color: var(--text-muted); font-weight: 500; margin: 0; line-height: 1.4;">Create a strong password for your account</p>
          </div>

          <form (submit)="$event.preventDefault(); handleForgotPasswordSubmit()" novalidate style="display: flex; flex-direction: column; gap: 20px;">
            <!-- Email Address Field (Readonly) -->
            <div class="form-group" style="text-align: left;">
              <label class="form-label" style="font-weight: 700; font-size: 0.95rem; color: var(--text-main); margin-bottom: 8px;">Email Address</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #64748b;"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>
                <input 
                  type="text" 
                  readonly 
                  [value]="forgotPasswordEmail"
                  class="form-input" 
                  style="height: 54px; padding-left: 44px; font-weight: 500; border-radius: 12px; background: var(--bg-button-secondary); border-color: transparent; color: var(--text-muted); cursor: not-allowed;"
                />
              </div>
            </div>

            <!-- Verification Code (6 OTP inputs) -->
            <div class="form-group" style="text-align: left;">
              <label class="form-label" style="font-weight: 700; font-size: 0.95rem; color: var(--text-main); margin-bottom: 8px;">Verification Code</label>
              <div style="display: flex; gap: 8px; justify-content: space-between;">
                @for (digit of [0, 1, 2, 3, 4, 5]; track digit) {
                  <input 
                    type="text" 
                    maxLength="1"
                    [id]="'forgot-otp-' + digit"
                    [value]="forgotPasswordOtpCode()[digit]"
                    (input)="onForgotPasswordOtpInput($event, digit)"
                    (keydown)="onForgotPasswordOtpKeyDown($event, digit)"
                    (paste)="onForgotPasswordOtpPaste($event)"
                    style="width: 52px; height: 52px; text-align: center; font-size: 1.25rem; font-weight: 700; border-radius: 12px; border: 1px solid var(--border-color); background: var(--bg-input); color: var(--text-main); box-shadow: 0 2px 4px rgba(0,0,0,0.02); transition: border-color 0.2s;"
                    onfocus="this.style.borderColor='var(--primary)';"
                    onblur="this.style.borderColor='var(--border-color)';"
                  />
                }
              </div>
              @if (forgotPasswordErrors()['code']) {
                <span class="form-error" style="color: #ef4444; font-size: 0.85rem; display: flex; align-items: center; gap: 6px; margin-top: 8px; font-weight: 500;"><svg width="14" height="14" viewBox="0 0 24 24" fill="#ef4444" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ forgotPasswordErrors()['code'] }}</span>
              }
            </div>

            <!-- New Password Field -->
            <div class="form-group" style="text-align: left;">
              <label class="form-label" style="font-weight: 700; font-size: 0.95rem; color: var(--text-main); margin-bottom: 8px;">New Password</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" [style.color]="forgotPasswordErrors()['new_password'] ? '#ef4444' : '#64748b'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                <input 
                  [type]="showForgotPasswordNewPassword() ? 'text' : 'password'" 
                  name="forgotPasswordNewPassword"
                  class="form-input" 
                  placeholder="••••••••"
                  [(ngModel)]="forgotPasswordNewPassword"
                  [style.borderColor]="forgotPasswordErrors()['new_password'] ? '#ef4444' : ''"
                  style="height: 54px; padding-left: 44px; padding-right: 46px; font-weight: 500; border-radius: 12px; font-size: 1rem; letter-spacing: 2px;"
                />
                <button type="button" (click)="showForgotPasswordNewPassword.set(!showForgotPasswordNewPassword())" style="position: absolute; right: 16px; background: none; border: none; cursor: pointer; color: var(--text-dim); display: flex; align-items: center; justify-content: center; padding: 0;">
                  @if (showForgotPasswordNewPassword()) {
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                  } @else {
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  }
                </button>
              </div>
              <!-- Dynamic Password Strength Checklist -->
              @if (forgotPasswordNewPassword) {
                @if (!hasEightForgotPassword || !hasUppercaseForgotPassword || !hasLowercaseForgotPassword || !hasSpecialForgotPassword) {
                  <div class="password-requirements" style="margin-top: 10px; display: flex; flex-direction: column; gap: 6px; padding: 12px; background: rgba(0,0,0,0.02); border-radius: 8px; border: 1px solid var(--border-color);">
                    <span style="font-size: 0.8rem; font-weight: 700; color: var(--text-muted); margin-bottom: 2px;">PASSWORD REQUIREMENTS:</span>
                    
                    @if (!hasEightForgotPassword) {
                      <div style="display: flex; align-items: center; gap: 8px; font-size: 0.82rem; font-weight: 500; transition: all 0.2s; color: #ef4444;">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                        At least 8 characters
                      </div>
                    }

                    @if (!hasUppercaseForgotPassword) {
                      <div style="display: flex; align-items: center; gap: 8px; font-size: 0.82rem; font-weight: 500; transition: all 0.2s; color: #ef4444;">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                        At least one uppercase letter
                      </div>
                    }

                    @if (!hasLowercaseForgotPassword) {
                      <div style="display: flex; align-items: center; gap: 8px; font-size: 0.82rem; font-weight: 500; transition: all 0.2s; color: #ef4444;">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                        At least one lowercase letter
                      </div>
                    }

                    @if (!hasSpecialForgotPassword) {
                      <div style="display: flex; align-items: center; gap: 8px; font-size: 0.82rem; font-weight: 500; transition: all 0.2s; color: #ef4444;">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                        At least one special character
                      </div>
                    }
                  </div>
                }
              }
              @if (forgotPasswordErrors()['new_password']) {
                <span class="form-error" style="color: #ef4444; font-size: 0.85rem; display: flex; align-items: center; gap: 6px; margin-top: 8px; font-weight: 500;"><svg width="14" height="14" viewBox="0 0 24 24" fill="#ef4444" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ forgotPasswordErrors()['new_password'] }}</span>
              }
            </div>

            <!-- Confirm Password Field -->
            <div class="form-group" style="text-align: left;">
              <label class="form-label" style="font-weight: 700; font-size: 0.95rem; color: var(--text-main); margin-bottom: 8px;">Confirm Password</label>
              <div class="form-input-wrapper">
                <svg class="form-input-icon" [style.color]="forgotPasswordErrors()['confirm_password'] ? '#ef4444' : '#64748b'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                <input 
                  [type]="showForgotPasswordConfirmPassword() ? 'text' : 'password'" 
                  name="forgotPasswordConfirmPassword"
                  class="form-input" 
                  placeholder="••••••••"
                  [(ngModel)]="forgotPasswordConfirmPassword"
                  [style.borderColor]="forgotPasswordErrors()['confirm_password'] ? '#ef4444' : ''"
                  style="height: 54px; padding-left: 44px; padding-right: 46px; font-weight: 500; border-radius: 12px; font-size: 1rem; letter-spacing: 2px;"
                />
                <button type="button" (click)="showForgotPasswordConfirmPassword.set(!showForgotPasswordConfirmPassword())" style="position: absolute; right: 16px; background: none; border: none; cursor: pointer; color: var(--text-dim); display: flex; align-items: center; justify-content: center; padding: 0;">
                  @if (showForgotPasswordConfirmPassword()) {
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                  } @else {
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  }
                </button>
              </div>
              @if (forgotPasswordErrors()['confirm_password']) {
                <span class="form-error" style="color: #ef4444; font-size: 0.85rem; display: flex; align-items: center; gap: 6px; margin-top: 8px; font-weight: 500;"><svg width="14" height="14" viewBox="0 0 24 24" fill="#ef4444" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {{ forgotPasswordErrors()['confirm_password'] }}</span>
              }
            </div>

            <!-- Submit button -->
            <button 
              type="submit" 
              [style.opacity]="(isResettingPassword() || forgotPasswordOtpCode().join('').length < 6 || !forgotPasswordNewPassword || forgotPasswordNewPassword !== forgotPasswordConfirmPassword) ? '0.6' : '1'"
              [style.cursor]="(isResettingPassword() || forgotPasswordOtpCode().join('').length < 6 || !forgotPasswordNewPassword || forgotPasswordNewPassword !== forgotPasswordConfirmPassword) ? 'not-allowed' : 'pointer'"
              style="width: 100%; height: 54px; font-weight: 700; display: flex; align-items: center; justify-content: center; border-radius: 16px; font-size: 1.05rem; background: #5b9385; color: #ffffff; border: none; transition: all 0.2s; position: relative; overflow: hidden;"
              [disabled]="isResettingPassword() || forgotPasswordOtpCode().join('').length < 6 || !forgotPasswordNewPassword || forgotPasswordNewPassword !== forgotPasswordConfirmPassword"
            >
              <span style="display: flex; align-items: center; justify-content: center; gap: 8px; transition: opacity 0.2s;" [style.opacity]="isResettingPassword() ? '0' : '1'">
                <span>Reset Password</span>
                <svg style="width: 20px; height: 20px;" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>
              @if (isResettingPassword()) {
                <span style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
                  <svg class="animate-spin" style="height: 20px; width: 20px; color: #ffffff;" fill="none" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" style="opacity: 0.25;"></circle>
                    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" style="opacity: 0.75;"></path>
                  </svg>
                </span>
              }
            </button>

            <!-- Back link -->
            <div style="text-align: center; font-size: 0.95rem; font-weight: 500; color: var(--text-muted);">
              Remember your password? <a href="#" (click)="$event.preventDefault(); isForgotPassword.set(false)" class="hover-underline" style="font-weight: 700; color: var(--text-main); text-decoration: none;">Sign in</a>
            </div>
          </form>
        }
      }


    </div>
  </div>
}
